module.exports = __webpack_public_path__ + "img/Weapon_38.36eafb59.png";